import React from "react";
import { MenuItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { Icon } from "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
const useStyles = makeStyles()((theme) => ({
  logoutContainer: {
    padding: theme.spacing(1, 2.5),
    gap: theme.spacing(2),
    "& .MuiListItemIcon-root": {
      minWidth: "unset"
    }
  },
  logoutContainerMinimize: {
    margin: "0 auto",
    width: "max-content"
  },
  logoutIcon: {
    fontSize: "18px"
  },
  logoutButton: {
    minWidth: "unset",
    color: theme.palette.text.primary
  }
}));
function Logout({ label, onLogout, minimizeMode }) {
  const { classes, cx } = useStyles();
  return /* @__PURE__ */ React.createElement(MenuItem, { onClick: onLogout, className: cx(classes.logoutContainer, minimizeMode && classes.logoutContainerMinimize) }, /* @__PURE__ */ React.createElement(ListItemIcon, null, /* @__PURE__ */ React.createElement(Icon, { icon: CustomIcon.Logout, className: classes.logoutIcon })), !minimizeMode && /* @__PURE__ */ React.createElement(ListItemText, { disableTypography: true }, /* @__PURE__ */ React.createElement(Typography, { variant: "body2" }, /* @__PURE__ */ React.createElement(LocalizedText, { label }))));
}
export {
  Logout
};
//# sourceMappingURL=Logout.js.map
